import get from 'lodash/get';

import {
  GET_NOTIFICATION_PREFERENCES_FAILURE,
  GET_NOTIFICATION_PREFERENCES_REQUESTED,
  GET_NOTIFICATION_PREFERENCES_SUCCESS,
  PUT_NOTIFICATION_PREFERENCES_FAILURE,
  PUT_NOTIFICATION_PREFERENCES_REQUESTED,
  PUT_NOTIFICATION_PREFERENCES_SUCCESS,
} from '../../../actionConstants';

import apiClient from '../../../apiClient';

const getNotificationPreferences = (dispatch) =>
  dispatch({
    type: GET_NOTIFICATION_PREFERENCES_REQUESTED,
    payload: apiClient.notificationPreferences
      .getNotificationPreferences()
      .then(
        (res) =>
          dispatch({
            type: GET_NOTIFICATION_PREFERENCES_SUCCESS,
            payload: get(res, 'data', []),
          }),
        (err) =>
          dispatch({
            type: GET_NOTIFICATION_PREFERENCES_FAILURE,
            payload: err,
          }),
      ),
  });

const putNotificationPreferences = (dispatch, data) =>
  dispatch({
    type: PUT_NOTIFICATION_PREFERENCES_REQUESTED,
    payload: apiClient.notificationPreferences
      .putNotificationPreferences(data)
      .then(
        () => {
          dispatch({
            type: PUT_NOTIFICATION_PREFERENCES_SUCCESS,
          });
          getNotificationPreferences(dispatch);
        },
        () =>
          dispatch({
            type: PUT_NOTIFICATION_PREFERENCES_FAILURE,
          }),
      ),
  });

export { getNotificationPreferences, putNotificationPreferences };
